import { Link } from "react-router-dom";

export interface EmptyPlanSearchProps {
  /** Visitor's search text, already trimmed by the parent. Shown inside curly quotes. */
  query: string;
  /** Clears the search so the catalog is shown again. */
  onClear: () => void;
}

export function EmptyPlanSearch({ query, onClear }: EmptyPlanSearchProps): JSX.Element {
  return (
    <div
      className="flex flex-col gap-3 rounded-card border px-4 py-6 md:px-6"
      style={{
        background: "var(--v3l-surface-base)",
        borderColor: "var(--v3l-border-divider)",
      }}
    >
      <p className="text-base font-semibold leading-6" style={{ color: "var(--v3l-text-primary)" }}>
        Nenhum plano encontrado para “{query}”
      </p>
      <p className="text-sm leading-6" style={{ color: "var(--v3l-text-secondary)" }}>
        Confira a grafia ou veja todos os planos. Se o seu concurso não está na lista, fale com a gente.
      </p>
      <div className="flex flex-col gap-2 md:flex-row">
        <button
          type="button"
          onClick={onClear}
          className="inline-flex min-h-[44px] w-full items-center justify-center rounded-chip px-4 text-sm font-medium md:w-auto"
          style={{
            background: "var(--v3l-surface-navy-band)",
            color: "var(--v3l-band-navy-heading)",
            border: "1px solid transparent",
          }}
        >
          Limpar busca
        </button>
        <Link
          to="/contato"
          className="inline-flex min-h-[44px] w-full items-center justify-center rounded-chip px-4 text-sm font-medium no-underline md:w-auto"
          style={{
            background: "var(--v3l-surface-base)",
            color: "var(--v3l-text-primary)",
            border: "1px solid var(--v3l-border-divider)",
          }}
        >
          Falar com a gente
        </Link>
      </div>
    </div>
  );
}
